module.exports = Date.now || now

function now() {
    return new Date().getTime()
}



//////////////////
// WEBPACK FOOTER
// ../~/date-now/index.js
// module id = 2207
// module chunks = 0